export const program = {
  current: "Current",
  pageTitle: "Your Program",
  matched: {
    headerCta: {
      crew: "Message crew",
      zoom: "Join the Zoom",
    },
    subheader: "Next session: <nobr>{{time}}</nobr>",
  },
  matching: {
    cta: "Contact us",
    description:
      "We’re still putting the finishing touches on your Program. We’ll send you an update when it’s ready to go! Any issues? Feel free to contact us.",
    imageAlt: "Screenshot of premium crew experience",
    subheader:
      "👋 Hi, it's your Conceive care team. We're working to curate your crew so this program material might be subject to change. Feel free to still browse through while you're waiting.",
  },
  materials: {
    title: "This week's materials",
  },
  speaker: "This week's speaker",
  survey: {
    cta: "Complete survey",
    text: "This week’s session includes a survey:",
  },
  title: "Your Program",
  type: {
    docx: "Word Document",
    link: "Link",
    pdf: "PDF",
  },
  upsell: {
    imageAlt: "Screenshot of premium crew experience",
    subheader:
      "A custom curriculum built for you by experts, with sessions each week.",
  },
  week: "Week",
};
